import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Card } from "./Card";
import { Button } from "./Button";

interface Props {
  emoji: string;
  titolo: string;
  messaggio: ReactNode;
  cta?: { label: string; to: string };
}

export function ErrorPage({ emoji, titolo, messaggio, cta }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Card className="max-w-md w-full text-center">
        <div className="text-6xl mb-4">{emoji}</div>
        <h1 className="text-2xl text-primary mb-3 font-serif">{titolo}</h1>
        <div className="text-secondary mb-6 leading-relaxed">{messaggio}</div>
        {cta && (
          <Link to={cta.to}>
            <Button variant="primary">{cta.label}</Button>
          </Link>
        )}
      </Card>
    </div>
  );
}
